import { useQuery } from "@tanstack/react-query";
import { Card, Col, Descriptions, Row, Spin, Table, Tag, Typography } from "antd";
import { useParams } from "react-router-dom";
import { eventService } from "../services/event.service";

const { Title } = Typography;

export function EventDetailPage() {
	const { id } = useParams();
	const { data, isLoading } = useQuery({
		queryKey: ["event", id],
		queryFn: () => eventService.get(Number(id)),
		enabled: !!id,
	});

	if (isLoading) return <Spin size="large" className="flex justify-center mt-20" />;

	const event = data?.data;
	if (!event) return <div>Topilmadi</div>;

	const typeLabels: Record<string, string> = { wedding: "To'y", celebration: "Bayram", conference: "Anjuman", other: "Boshqa" };

	return (
		<div>
			<Title level={3}>Tadbir #{event.id} — {event.wedding_hall?.name}</Title>
			<Row gutter={16}>
				<Col span={12}>
					<Card title="Ma'lumotlar">
						<Descriptions column={1} bordered size="small">
							<Descriptions.Item label="To'yxona">{event.wedding_hall?.name}</Descriptions.Item>
							<Descriptions.Item label="Turi"><Tag>{typeLabels[event.event_type] || event.event_type}</Tag></Descriptions.Item>
							<Descriptions.Item label="Boshlanish">{event.started_at}</Descriptions.Item>
							<Descriptions.Item label="Tugash">{event.ended_at || "Davom etmoqda"}</Descriptions.Item>
							<Descriptions.Item label="Pik odam soni">{event.peak_count}</Descriptions.Item>
							<Descriptions.Item label="O'rtacha odam soni">{event.avg_count}</Descriptions.Item>
							<Descriptions.Item label="Auto aniqlangan">{event.is_auto_detected ? "Ha" : "Yo'q"}</Descriptions.Item>
							<Descriptions.Item label="Izoh">{event.note || "—"}</Descriptions.Item>
						</Descriptions>
					</Card>
				</Col>
				<Col span={12}>
					<Card title="Aniqlangan sanatkorlar">
						<Table
							dataSource={event.artists || []}
							rowKey="id"
							pagination={false}
							size="small"
							columns={[
								{ title: "Sanatkor", key: "name", render: (_: unknown, r: { artist?: { name: string; stage_name?: string } }) => `${r.artist?.name || "—"} ${r.artist?.stage_name ? `(${r.artist.stage_name})` : ""}` },
								{ title: "Ishonch", dataIndex: "confidence", render: (v: number) => v ? `${(v * 100).toFixed(0)}%` : "—" },
								{ title: "Vaqt", dataIndex: "detected_at" },
							]}
						/>
					</Card>
				</Col>
			</Row>
		</div>
	);
}
